module.exports = __webpack_public_path__ + "img/you-know.705caf46.png";